/**
 * @bref    Fonctionnalitées jQuery relatives au formulaire des Documents.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// Products - Display upload file name
//#####################################################
$('.file-input, .file-select').on('change', function() {
    var fileName = $(this).val().split('\\').pop();
    $(this).parents('.file-select:first').find('.display-filename').text(fileName);
});

//#####################################################
// Clear modale content when add document
//#####################################################
$('button.add-document-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-add-document input:not([type=hidden])').each(function() { $(this).val(''); });
    $('form#confirm-add-document textarea').each(function() { $(this).val(''); });
});

//#####################################################
// Send document informations to the update modale
//#####################################################
$('button.update-document-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-update-document').attr('action', $(this).data('url'));
    // Modal document data
    $('form#confirm-update-document input[name=name]').val($(this).data('name'));
    $('form#confirm-update-document textarea[name=description]').val($(this).data('description'));
});

//#####################################################
// Clear modale content when add product
//#####################################################
$('button.add-product-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-add-product input:not([type=hidden])').each(function() { $(this).val(''); });
});

//#####################################################
// Send product informations to the update modale
//#####################################################
$('button.update-product-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-update-product').attr('action', $(this).data('url'));
    // Modal document data
    $('form#confirm-update-product input[name=name]').val($(this).data('name'));
    $('form#confirm-update-product input[name=alloy]').val($(this).data('alloy'));
    $('form#confirm-update-product input[name=price]').val($(this).data('price'));
    $('form#confirm-update-product input[name=density]').val(parseFloat($(this).data('density')).toFixed(4));
});

//#####################################################
// Send delete document url to the modale form action
//#####################################################
$('button.delete-document-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-delete-document').attr("action", $(this).data('url'));
});

//#####################################################
// Send row ID to the remove modale
//#####################################################
$('button.remove-row-btn').on('click', function(event) {
    event.stopPropagation();
    // Send row ID to hidden input
    $('input#confirm-remove-row-id').val($(this).data('row'));
});

//#####################################################
// Remove row table confirmation
//#####################################################
$('button#confirm-remove-row').on('click', function(event) {
    event.stopPropagation();
    // Get row ID from hidden input
    let row = $('input#confirm-remove-row-id').val();
    // Delete row by ID
    if (row) {
        $('tr[id="' + row + '"]').remove();
    }
});
